module.exports = __webpack_public_path__ + "static/media/icon-star.60a42105.svg";